export const companySettings = () => {
  return {
    admin_access: 'Manage field forms (published & drafts), users, and company settings.',
    coordinator_access: 'Manage field forms (published & drafts).',
    form_builder_access: 'Create new draft field forms.  No ability to edit publish field forms.',
    view_only_access: 'View only published & draft field forms.',
    logo_message: 'This logo will be displayed on the FieldTech Connect Mobile App, Invitation Emails, and Reports.',
    title: 'Company Settings',
    compliant: 'COMPLIANT',
    mobile_only: 'Mobile Only',
    missing: 'Missing',
    upload_logo: 'Upload Company Logo',
    info_card: {
      title: 'COMPANY INFO',
      name: 'Company Legal Name',
      name_placeholder: 'Enter company name',
      legal_entity: 'Legal Entity (LLC, C-Corp, etc)',
      address: 'Company Address',
      street: 'Street',
      city: 'City',
      zip_code: 'Zip/Postal Code',
      license: 'License#',
      contractor_license: 'Contractor License #',
      phone: 'Phone Number',
      company_phone: 'Company Phone Number',
      fax: 'Fax Number',
      mail: 'Company Email',
      dba: 'Comp. DBA',
      state: 'State(s) Company is Registered',
      state_placholder: 'Enter state company is registered',
      country: 'Country(s) of Operation',
      website: 'Company Website',
      edit_logo: 'Edit Logo',
      add_logo: 'Add Logo'
    },
    profile_card: {
      title: 'PROFILE',
      content: 'Amazing things are coming soon!'
    },
    roles_card: {
      title: 'ROLES',
      create_users: 'Create Users',
      edit_users: 'Edit Users',
      delete_users: 'Delete Users',
      wo_view: 'View Work Orders',
      workorders: 'Work Orders',
      invoices: 'Invoices',
      company_settings: 'Company Profile',
      sites: 'Sites',
      no_portal_access: 'No Portal Access',
      manage_access: 'Manage Access',
      panel_new: 'New Access',
      panel_details: 'Access Details',
      panel_name: 'Name',
      panel_users: 'Manage Users',
      panel_dash: 'View Dashboard',
      panel_wo: 'View Work Orders',
      panel_prop: 'View Proposals',
      panel_create: 'Create',
      panel_delete: 'Delete',
      panel_save: 'Save',
      panel_edit: 'Edit',
      panel_yes: 'Yes',
      panel_no: 'No',
      panel_select: 'Select',
      access_name: 'Access Name',
      report_scheduler: 'Report Scheduler Admin'
    },
    users_card: {
      panel_access: 'Access',
      title: 'USERS',
      name: 'Name',
      first_and_last_name: 'First and Last Name',
      role: 'Role',
      company_role: 'Company Role',
      access: 'Access Level',
      panel_new: 'New User',
      panel_details: 'User Details',
      panel_name: 'Name',
      panel_first_and_last_name: 'First and Last Name',
      panel_mail: 'Email Address',
      panel_role: 'Title',
      panel_company_role: 'Company Role',
      panel_portal: 'Web portal access',
      user_name_placeholder: 'User Name and Last Name',
      user_email_placeholder: 'User Email Address',
      user_role_placeholder: 'User Role',
      user_company_role_placeholder: 'User Company Role',
      pending: 'pending',
      user_already_exists: 'User already exists',
      search: 'Search user',
      notifications: 'Notifications'
    },
    reports_card: {
      title: 'Scheduled Reports',
      name: 'Report name',
      frequency: 'Frequency',
      sites: 'Site(s)',
      status: 'Status',
      creator: 'Creator',
      panel_title: 'Report',
      panel_name: 'Report Name',
      panel_name_placeholder: 'Enter name',
      panel_mail_to: 'Recipients (To)',
      panel_mail_placeholder: 'Enter email address and press enter',
      panel_mail_cc: 'Recipients (cc)',
      panel_client_name: 'Client Name',
      panel_client_name_placeholder: 'Search Client Name',
      send_on: 'Send Email On (day/time)',
      data_range: 'Date range of data in report',
      trades: 'Trade(s)',
      wo_status: 'Work Order Status',
      email_ends: 'Email Ends',
      active_report: 'Active',
      inactive_report: 'Inactive',
      view_more: 'View More'
    },
    bes_reports_card: {
      name: 'Name',
      reports: 'Scheduled Reports'
    },
    bes_notifications_card: {
      title: 'Notifications',
      name: 'Name',
      action: 'Action',
      client: 'Client',
      creator: 'Creator',
      view_more: 'View More'
    },
    bes_notifications_panel: {
      title: 'Notification',
      name: 'Notification Name',
      name_placeholder: 'Enter name',
      mail_to: 'Recipients (To)',
      mail_placeholder: 'Enter email address and press enter',
      mail_cc: 'Recipients (cc)',
      client_name: 'Client Name',
      client_name_placeholder: 'Search Client Name',
      send_notifications_when: 'Send Email Notification When',
      delete: 'Delete',
      save: 'Save',
      create: 'Create',
      options: {
        client_log_in: 'Client Log In',
        client_runs_report: 'Client Runs Report',
        client_creates_user: 'Client Creates User',
        client_submits_service_request: 'Client Submits Service Request'
      }
    },
    buttons: {
      edit: 'Edit',
      show_more: 'Show More',
      add: 'Add'
    },
    card: {
      users: 'Users',
      profile: 'Company Profile',
      trades: 'Trades & Services',
      service: 'Service Area',
      web_users: 'Web Portal Users',
      field_users: 'FieldTech Mobile Users',
      roles: 'User Roles',
      name: 'Name and Details',
      insurance: 'Company Info & Insurance',
      expiration: 'Expiration',
      coi: 'COI Policy #',
      comp: 'Workers Compensation #',
      w9: 'W9 form',
      save: 'Save',
      update: 'Update logo',
      update_question: 'Are you sure you want to update the Company logo?',
      cancel: 'Cancel',
      no_file: 'No document uploaded',
      access: 'Access'
    },
    support_card: {
      title: 'Technical Support',
      policy: 'Privacy Policy',
      conditions: 'Terms and Conditions',
      terms_of_use: 'Terms of Use',
      version: 'Software Version',
      knowledge: 'Knowledge Base Support',
      privacy_policy: 'Privacy Policy'
    },
    preferences_card: {
      title: 'Preferences',
      work_types: 'Work Types',
      description: 'Control which work types are visible.',
      clear: 'Clear',
      apply: 'Apply',
      types: {
        maintenance: 'Maintenance',
        enhancement: 'Enhancement',
        seasonal: 'Seasonal',
        complaint: 'Complaint'
      },
      no_file: 'No document uploaded'
    }
  }
}
